export enum Gender {
  MASCULINE = 'M',
  FEMININE = 'F',
}



// WEBPACK FOOTER //
// ./ts/app/overlay/gender.ts